import type { Sprint } from '../../../model/types';
import type { State } from '../../types';

export const getSprints = (state: State): Sprint[] => state.entities.sprints;
